
const digest = '97745ce4b9fcc7520c60b4225049fa0c249bf45ee413503782a56516729f3777';
const classes = {"wrapper":"_wrapper_1ihc4_1"};
const css = `._wrapper_1ihc4_1 {
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-family: "Rubik", sans-serif;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  